// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActorPoseWire, ActorPoseWireT } from '../mannequin/actor-pose-wire';
import { BallPolynomialWire, BallPolynomialWireT } from '../mannequin/ball-polynomial-wire';
import { GameEventWire, GameEventWireT } from '../mannequin/game-event-wire';
import { SkeletalPositionWire, SkeletalPositionWireT } from '../mannequin/skeletal-position-wire';
import { TrackedEventWire, TrackedEventWireT } from '../mannequin/tracked-event-wire';
import { TrackingBatPositionWire, TrackingBatPositionWireT } from '../mannequin/tracking-bat-position-wire';
import { Vec3Wire, Vec3WireT } from '../mannequin/vec3-wire';


export class TrackingFrameWire implements flatbuffers.IUnpackableObject<TrackingFrameWireT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):TrackingFrameWire {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsTrackingFrameWire(bb:flatbuffers.ByteBuffer, obj?:TrackingFrameWire):TrackingFrameWire {
  return (obj || new TrackingFrameWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsTrackingFrameWire(bb:flatbuffers.ByteBuffer, obj?:TrackingFrameWire):TrackingFrameWire {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TrackingFrameWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

actorPoses(index: number, obj?:ActorPoseWire):ActorPoseWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new ActorPoseWire()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

actorPosesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

ballPosition(obj?:Vec3Wire):Vec3Wire|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new Vec3Wire()).__init(this.bb_pos + offset, this.bb!) : null;
}

gameEvents(index: number, obj?:GameEventWire):GameEventWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new GameEventWire()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

gameEventsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

trackedEvents(index: number, obj?:TrackedEventWire):TrackedEventWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new TrackedEventWire()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

trackedEventsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

inferredBat(obj?:TrackingBatPositionWire):TrackingBatPositionWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new TrackingBatPositionWire()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

ballPolynomials(index: number, obj?:BallPolynomialWire):BallPolynomialWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new BallPolynomialWire()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

ballPolynomialsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

rawJoints(index: number, obj?:SkeletalPositionWire):SkeletalPositionWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new SkeletalPositionWire()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

rawJointsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

num():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

time():number {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
}

timestamp():string|null
timestamp(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
timestamp(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startTrackingFrameWire(builder:flatbuffers.Builder) {
  builder.startObject(10);
}

static addActorPoses(builder:flatbuffers.Builder, actorPosesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, actorPosesOffset, 0);
}

static createActorPosesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startActorPosesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addBallPosition(builder:flatbuffers.Builder, ballPositionOffset:flatbuffers.Offset) {
  builder.addFieldStruct(1, ballPositionOffset, 0);
}

static addGameEvents(builder:flatbuffers.Builder, gameEventsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, gameEventsOffset, 0);
}

static createGameEventsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startGameEventsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addTrackedEvents(builder:flatbuffers.Builder, trackedEventsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, trackedEventsOffset, 0);
}

static createTrackedEventsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startTrackedEventsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addInferredBat(builder:flatbuffers.Builder, inferredBatOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, inferredBatOffset, 0);
}

static addBallPolynomials(builder:flatbuffers.Builder, ballPolynomialsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, ballPolynomialsOffset, 0);
}

static createBallPolynomialsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startBallPolynomialsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addRawJoints(builder:flatbuffers.Builder, rawJointsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, rawJointsOffset, 0);
}

static createRawJointsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startRawJointsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addNum(builder:flatbuffers.Builder, num:number) {
  builder.addFieldInt32(7, num, 0);
}

static addTime(builder:flatbuffers.Builder, time:number) {
  builder.addFieldFloat64(8, time, 0.0);
}

static addTimestamp(builder:flatbuffers.Builder, timestampOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, timestampOffset, 0);
}

static endTrackingFrameWire(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): TrackingFrameWireT {
  return new TrackingFrameWireT(
    this.bb!.createObjList<ActorPoseWire, ActorPoseWireT>(this.actorPoses.bind(this), this.actorPosesLength()),
    (this.ballPosition() !== null ? this.ballPosition()!.unpack() : null),
    this.bb!.createObjList<GameEventWire, GameEventWireT>(this.gameEvents.bind(this), this.gameEventsLength()),
    this.bb!.createObjList<TrackedEventWire, TrackedEventWireT>(this.trackedEvents.bind(this), this.trackedEventsLength()),
    (this.inferredBat() !== null ? this.inferredBat()!.unpack() : null),
    this.bb!.createObjList<BallPolynomialWire, BallPolynomialWireT>(this.ballPolynomials.bind(this), this.ballPolynomialsLength()),
    this.bb!.createObjList<SkeletalPositionWire, SkeletalPositionWireT>(this.rawJoints.bind(this), this.rawJointsLength()),
    this.num(),
    this.time(),
    this.timestamp()
  );
}


unpackTo(_o: TrackingFrameWireT): void {
  _o.actorPoses = this.bb!.createObjList<ActorPoseWire, ActorPoseWireT>(this.actorPoses.bind(this), this.actorPosesLength());
  _o.ballPosition = (this.ballPosition() !== null ? this.ballPosition()!.unpack() : null);
  _o.gameEvents = this.bb!.createObjList<GameEventWire, GameEventWireT>(this.gameEvents.bind(this), this.gameEventsLength());
  _o.trackedEvents = this.bb!.createObjList<TrackedEventWire, TrackedEventWireT>(this.trackedEvents.bind(this), this.trackedEventsLength());
  _o.inferredBat = (this.inferredBat() !== null ? this.inferredBat()!.unpack() : null);
  _o.ballPolynomials = this.bb!.createObjList<BallPolynomialWire, BallPolynomialWireT>(this.ballPolynomials.bind(this), this.ballPolynomialsLength());
  _o.rawJoints = this.bb!.createObjList<SkeletalPositionWire, SkeletalPositionWireT>(this.rawJoints.bind(this), this.rawJointsLength());
  _o.num = this.num();
  _o.time = this.time();
  _o.timestamp = this.timestamp();
}
}

export class TrackingFrameWireT implements flatbuffers.IGeneratedObject {
constructor(
  public actorPoses: (ActorPoseWireT)[] = [],
  public ballPosition: Vec3WireT|null = null,
  public gameEvents: (GameEventWireT)[] = [],
  public trackedEvents: (TrackedEventWireT)[] = [],
  public inferredBat: TrackingBatPositionWireT|null = null,
  public ballPolynomials: (BallPolynomialWireT)[] = [],
  public rawJoints: (SkeletalPositionWireT)[] = [],
  public num: number = 0,
  public time: number = 0.0,
  public timestamp: string|Uint8Array|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const actorPoses = TrackingFrameWire.createActorPosesVector(builder, builder.createObjectOffsetList(this.actorPoses));
  const gameEvents = TrackingFrameWire.createGameEventsVector(builder, builder.createObjectOffsetList(this.gameEvents));
  const trackedEvents = TrackingFrameWire.createTrackedEventsVector(builder, builder.createObjectOffsetList(this.trackedEvents));
  const inferredBat = (this.inferredBat !== null ? this.inferredBat!.pack(builder) : 0);
  const ballPolynomials = TrackingFrameWire.createBallPolynomialsVector(builder, builder.createObjectOffsetList(this.ballPolynomials));
  const rawJoints = TrackingFrameWire.createRawJointsVector(builder, builder.createObjectOffsetList(this.rawJoints));
  const timestamp = (this.timestamp !== null ? builder.createString(this.timestamp!) : 0);

  TrackingFrameWire.startTrackingFrameWire(builder);
  TrackingFrameWire.addActorPoses(builder, actorPoses);
  TrackingFrameWire.addBallPosition(builder, (this.ballPosition !== null ? this.ballPosition!.pack(builder) : 0));
  TrackingFrameWire.addGameEvents(builder, gameEvents);
  TrackingFrameWire.addTrackedEvents(builder, trackedEvents);
  TrackingFrameWire.addInferredBat(builder, inferredBat);
  TrackingFrameWire.addBallPolynomials(builder, ballPolynomials);
  TrackingFrameWire.addRawJoints(builder, rawJoints);
  TrackingFrameWire.addNum(builder, this.num);
  TrackingFrameWire.addTime(builder, this.time);
  TrackingFrameWire.addTimestamp(builder, timestamp);

  return TrackingFrameWire.endTrackingFrameWire(builder);
}
}
